<template>
    <InputBox v-model="inputValue"
              :label-class="!!inputValue ? 'validated' : (!!isInvalid ? 'invalid' : '')"
              :label="measurement.name"
              :unit="measurement.unit"
              @focus="$emit('focus', $event)">
        <span class="helper-icon d-md-none" @click="$emit('openHelper')">?</span>
    </InputBox>
</template>

<script>
import InputBox from "./InputBox";

export default {
    name: "MeasurementInputBox",
    components: {InputBox},
    props: [
        "measurement",
        "validate",
    ],
    data() {
        return {
            isInvalid: false
        };
    },
    watch: {
        validate(value) {
            if (value)
                this.isInvalid = !this.inputValue;
        }
    },
    computed: {
        defaultValue() {
            let baseValue = this.$db.measurements[this.$backendConfig.measurements.baseDefaultsOn];

            // Base measurement not set yet
            if (typeof baseValue === "undefined")
                return null;

            // Default values for selected base measurement value
            let defaults = this.$backendConfig.measurements.defaultValues[baseValue];

            return defaults ? defaults[this.measurement.id] : null;
        },
        inputValue: {
            set(value) {
                this.isInvalid = !value;
                this.$set(this.$db.measurements, this.measurement.id, value);
                this.$set(this.$db.measurements, "_updatedAt", false);
                this.$set(this.$db.measurements, "_isOutdated", false);
            },
            get() {
                let measurementValue = this.$db.measurements[this.measurement.id];

                // Product option not selected yet -> pick the default one
                if (typeof measurementValue === "undefined")
                    return this.defaultValue;

                return measurementValue;
            }
        }
    }
}
</script>
